import { Link } from "react-router";
import { Button } from "@/components/ui/button.tsx";
import {
  Accessibility,
  CalendarSync,
  ChevronRight,
  FileText,
  GlobeLock,
  Headset,
  Lock,
  UserX,
} from "lucide-react";
import { Separator } from "@/components/ui/separator.tsx";
import { useTranslation } from "@/i18n";

const More = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="flex flex-col gap-2">
        <Link to="/subscriptions" className="w-full">
          <Button
            variant="outline"
            className="bg-card flex w-full items-center justify-between px-4 py-6"
          >
            <div className="flex items-center">
              <CalendarSync className="text-muted-foreground mr-3 size-5" />
              <span>{t("nav.subscriptions")}</span>
            </div>
            <ChevronRight className="text-muted-foreground size-5" />
          </Button>
        </Link>
        <Link to="/support" className="w-full">
          <Button
            variant="outline"
            className="bg-card flex w-full items-center justify-between px-4 py-6"
          >
            <div className="flex items-center">
              <Headset className="text-muted-foreground mr-3 size-5" />
              <span>{t("nav.support")}</span>
            </div>
            <ChevronRight className="text-muted-foreground size-5" />
          </Button>
        </Link>

        <Link to="/change-password" className="w-full">
          <Button
            variant="outline"
            className="bg-card flex w-full items-center justify-between px-4 py-6"
          >
            <div className="flex items-center">
              <Lock className="text-muted-foreground mr-3 size-5" />
              <span>{t("nav.changePassword")}</span>
            </div>
            <ChevronRight className="text-muted-foreground size-5" />
          </Button>
        </Link>

        <Separator />

        <Link to="/terms-of-service" className="w-full">
          <Button
            variant="outline"
            className="bg-card flex w-full items-center justify-between px-4 py-6"
          >
            <div className="flex items-center">
              <FileText className="text-muted-foreground mr-3 size-5" />
              <span>{t("nav.termsOfService")}</span>
            </div>
            <ChevronRight className="text-muted-foreground size-5" />
          </Button>
        </Link>

        <Link to="/gdpr" className="w-full">
          <Button
            variant="outline"
            className="bg-card flex w-full items-center justify-between px-4 py-6"
          >
            <div className="flex items-center">
              <FileText className="text-muted-foreground mr-3 size-5" />
              <span>{t("nav.gdpr")}</span>
            </div>
            <ChevronRight className="text-muted-foreground size-5" />
          </Button>
        </Link>

        <Link to="/privacy-policy" className="w-full">
          <Button
            variant="outline"
            className="bg-card flex w-full items-center justify-between px-4 py-6"
          >
            <div className="flex items-center">
              <GlobeLock className="text-muted-foreground mr-3 size-5" />
              <span>{t("nav.privacyPolicy")}</span>
            </div>
            <ChevronRight className="text-muted-foreground size-5" />
          </Button>
        </Link>

        <Link to="/accessibility" className="w-full">
          <Button
            variant="outline"
            className="bg-card flex w-full items-center justify-between px-4 py-6"
          >
            <div className="flex items-center">
              <Accessibility className="text-muted-foreground mr-3 size-5" />
              <span>{t("nav.accessibility")}</span>
            </div>
            <ChevronRight className="text-muted-foreground size-5" />
          </Button>
        </Link>

        <Link to="/complaints" className="w-full">
          <Button
            variant="outline"
            className="bg-card flex w-full items-center justify-between px-4 py-6"
          >
            <div className="flex items-center">
              <UserX className="text-muted-foreground mr-3 size-5" />
              <span>{t("nav.complaints")}</span>
            </div>
            <ChevronRight className="text-muted-foreground size-5" />
          </Button>
        </Link>
        <img
          src="/begambleaware.png"
          alt={t("common.beGambleAware")}
          className="mx-auto w-1/3 invert dark:invert-0"
        />

        <img
          src="/praxislogo.png"
          alt={t("common.poweredByPraxis")}
          className="mx-auto w-2/3 invert dark:invert-0"
        />
      </div>
    </>
  );
};

export default More;
